import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-discount-scholarships',
  templateUrl: './discount-scholarships.component.html',
  styleUrls: ['./discount-scholarships.component.css']
})
export class DiscountScholarshipsComponent implements OnInit {

  @Input() DiscountScholarships: number;

  //@Output() filterProgramsEvent = new EventEmitter();
  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  //this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/components/discount-scholarships/discount-scholarships.component.ts